import React from 'react';
import NavBar from './NavBar';
import WhatsAppFloat from './WhatsAppFloat';

const Layout = ({ children }) => (
  <>
    <NavBar />
    <main style={{ background: 'var(--bg-ink-solid)', color: 'var(--color-text)', minHeight: '100vh' }}>
      {children}
    </main>
    <WhatsAppFloat />
  </>
);

export default Layout;
